export enum DayShortName {
    Mon = 'Mon',
    Tue = 'Tue',
    Wed = 'Wed',
    Thu = 'Thu',
    Fri = 'Fri',
    Sat = 'Sat',
    Sun = 'Sun'
}

export enum DayFullName {
    Mon = 'Monday',
    Tue = 'Tuesday',
    Wed = 'Wednesday',
    Thu = 'Thursday',
    Fri = 'Friday',
    Sat = 'Saturday',
    Sun = 'Sunday'
}

export enum DayRelative {
    Today = 'Today',
    Tomorrow = 'Tomorrow',
    Yesterday = 'Yesterday'
}

export function DayNumber(key: DayShortName) {

    const map = {
        [DayShortName.Mon]: 1,
        [DayShortName.Tue]: 2,
        [DayShortName.Wed]: 3,
        [DayShortName.Thu]: 4,
        [DayShortName.Fri]: 5,
        [DayShortName.Sat]: 6,
        [DayShortName.Sun]: 0
    }

    return map[key];
}

export const getNextDays = (day: DayShortName) => {

    const days = Object.values(DayShortName);
    const index = days.indexOf(day);

    const before = index === 0
        ? []
        : days.slice(0, index);

    const after = index === days.length - 1
        ? []
        : days.slice(index + 1);

    return [...after, ...before];

}